import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export const WrapperImage = styled.img`
  height: 24px;
  width: 24px;
  padding: 6px 6px;
  border-radius: 50%;
  background-color: #e2dffd;
`;

export const WrapperMessage = styled.span`
  font-size: 14px;
  line-height: 24px;
  color: #1a055d;

  > b {
    font-weight: 900;
  }
`;
